import React, { useState, useRef, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { BsX } from 'react-icons/bs';
import aiResponses from '../../data/onboarding-ai-responses';

const LearnWithAI = ({ show, onClose, question, isCorrect }) => {
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState(
    isCorrect
      ? `Help me understand more about ${question?.questionname}`
      : 'Help me understand why my answer was incorrect'
  );
  const [userMessageCount, setUserMessageCount] = useState(0);
  const chatEndRef = useRef(null);

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  const handleSendMessage = () => {
    if (!userMessage.trim()) return;

    setMessages((prev) => [...prev, { sender: 'user', text: userMessage }]);
    setUserMessage('');
    setUserMessageCount((count) => count + 1);

    setTimeout(() => {
      const responseList = aiResponses[question?.questionid] || [];
      const randomResponse =
        responseList.length > 0
          ? responseList[Math.floor(Math.random() * responseList.length)]
          : "You've hit the AI limit. Upgrade to continue.";

      setMessages((prev) => [
        ...prev,
        { sender: 'ai', text: randomResponse }
      ]);
    }, 800);
  };

  const handleUpgradeClick = () => {
    window.open("https://buy.stripe.com/eVa29y1Ig8zsgFycMZ", "_blank", "noopener,noreferrer");
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header
        className="d-flex justify-content-between align-items-center border-0"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <h5 className="fw-bold mb-0" style={{ color: '#FF7C24' }}>
          Learn with AI
        </h5>
        <Button
          variant="link"
          onClick={onClose}
          aria-label="Close"
          style={{ fontSize: '1.5rem', color: '#232830' }}
        >
          <BsX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
          backgroundColor: '#FFFFFF',
          padding: '1rem',
        }}
      >
        <div className="d-flex flex-column gap-3">
          {messages.map((msg, idx) => (
            <div
              key={idx}
              style={{
                alignSelf: msg.sender === 'user' ? 'flex-end' : 'flex-start',
                backgroundColor: msg.sender === 'user' ? '#007BFF' : '#232830',
                color: '#FFFFFF',
                padding: '12px 16px',
                borderRadius: '16px',
                maxWidth: '80%',
                fontSize: '16px',
                lineHeight: '1.4',
                textAlign: msg.sender === 'user' ? 'right' : 'left',
              }}
            >
              {msg.text}
            </div>
          ))}
          <div ref={chatEndRef}></div>
        </div>
      </Modal.Body>

      <Modal.Footer
        className="border-0"
        style={{
          flexDirection: 'column',
          gap: '10px',
          backgroundColor: '#232830',
          width: '100%',
          padding: '20px',
        }}
      >
        {userMessageCount < 3 ? (
          <div
            style={{
              display: 'flex',
              gap: '10px',
              width: '100%',
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            <Form.Control
              type="text"
              placeholder="Ask a question..."
              value={userMessage}
              onChange={(e) => setUserMessage(e.target.value)}
              style={{
                flex: 1,
                minHeight: '50px',
                backgroundColor: '#FFFFFF',
                color: '#232830',
                borderRadius: '12px',
                border: '1px solid #CED4DA',
                fontSize: '16px',
                padding: '0.75rem',
              }}
            />
            <Button
              onClick={handleSendMessage}
              disabled={!userMessage.trim()}
              style={{
                minWidth: '100px',
                minHeight: '50px',
                backgroundColor: '#FF7C24',
                borderColor: '#FF7C24',
                color: '#FFFFFF',
                fontWeight: 'bold',
                borderRadius: '12px',
                fontSize: '16px',
              }}
            >
              Send
            </Button>
          </div>
        ) : (
          <div
            style={{
              backgroundColor: '#FFFFFF',
              padding: '20px',
              borderRadius: '16px',
              width: '100%',
              color: '#232830',
              textAlign: 'center',
            }}
          >
            <p style={{ fontWeight: 'bold', fontSize: '17px' }}>Upgrade to FinTorro Pro and get:</p>
            <ul className="list-unstyled" style={{ fontSize: '15px', lineHeight: '1.6' }}>
              <li>• Unlimited Lessons & Practice</li>
              <li>• Learn with AI</li>
              <li>• 10,000+ Interactive Lessons</li>
              <li>• Crypto, Forex, Stocks & More</li>
              <li>• Join Challenges & Earn Rewards</li>
            </ul>
            <Button
              onClick={handleUpgradeClick}
              style={{
                marginTop: '10px',
                backgroundColor: '#FF7C24',
                borderColor: '#FF7C24',
                fontWeight: 'bold',
                borderRadius: '12px',
                padding: '10px 20px',
              }}
            >
              Upgrade to Pro
            </Button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default LearnWithAI;





